import { NumberFormatter as MantineNumberFormatter } from '@mantine/core';

export const NumberFormatter = MantineNumberFormatter.extend({
	defaultProps: {
		decimalScale: 2,
		thousandSeparator: ' ',
		fixedDecimalScale: true,
	},
});
